type LogLevel = 'log' | 'warn' | 'error' | 'info' | 'debug' | 'trace';

const createLoggerMethod = (level: LogLevel, context: string) => {
	return (...args: any[]) => {
		if (import.meta.env.VITE_NODE_ENV !== 'production') {
			console[level](`[${context}]`, ...args);
		}
	};
};

export const createLogger = (context: string) => {
	return {
		log: createLoggerMethod('log', context),
		error: createLoggerMethod('error', context),
		warn: createLoggerMethod('warn', context),
		info: createLoggerMethod('info', context),
		debug: createLoggerMethod('debug', context),
		trace: createLoggerMethod('trace', context),
	};
};

//przykładowe użycie:
//const logger = createLogger('AuthModule');
//logger.log('Użytkownik zalogowany');
//logger.error('Błąd logowania', error);
